import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import SystemInformation from '@/components/SystemInformation'
import PortStatus from '@/components/PortStatus'
import PortConfigure from '@/components/PortConfigure'
import PortStatistics from '@/components/PortStatistics'
import Lacp from '@/components/Lacp'
import SystemLog from '@/components/SystemLog'
import Vlan from '@/components/VLAN'
import MacAddressTable from '@/components/MacAddressTable'
import RateLimiting from '@/components/RateLimiting'
import AclIp from '@/components/AclIp'
import AclMac from '@/components/AclMac'
import IgmpStatistic from '@/components/IgmpStatistic'
import Qos from '@/components/Qos'
import Mirroring from '@/components/Mirroring'
import lldpConfig from '@/components/LldpConfig'
import lldpRemote from '@/components/LldpRemote'
import SystemDhcp from '@/components/SystemDhcp'
import SystemPassword from '@/components/SystemPassword'
import SystemTime from '@/components/SystemTime'
import SystemHttps from '@/components/SystemHttps'
import Dashboard from '@/components/Dashboard'
import IgmpSnooping from '@/components/IgmpSnooping'
import LiveUpdate from '@/components/LiveUpdate'
import FirmwareUpdate from '@/components/FirmwareUpdate'
import Rstp from '@/components/Rstp'
import SystemBackup from '@/components/SystemBackup'
import SystemSnmp from '@/components/SystemSnmp'
import Debug from '@/components/Debug'
import PoeConfiguration from '@/components/PoeConfiguration'
import PoeConsumption from '@/components/PoeConsumption'
import PoeSchedule from '@/components/PoeSchedule'
import LoopProtection from '@/components/LoopProtection'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/port',
      name: 'port',
      alias: 'portstatus',
      component: PortStatus
    },
    {
      path: '/portstatus',
      name: 'portstatus',
      component: PortStatus
    },
    {
      path: '/portconfigure',
      name: 'portconfigure',
      component: PortConfigure
    },
    {
      path: '/portstatistics',
      name: 'portstatistics',
      component: PortStatistics
    },
    {
      path: '/vlan',
      name: 'vlan',
      component: Vlan
    },
    {
      path: '/lag',
      name: 'lag',
      component: Lacp
    },
    {
      path: '/rstp',
      name: 'rstp',
      component: Rstp
    },
    {
      path: '/mactable',
      name: 'mactable',
      component: MacAddressTable
    },
    {
      path: '/trafficrate',
      name: 'trafficrate',
      component: RateLimiting
    },
    {
      path: '/aclip',
      name: 'acl',
      component: AclIp
    },
    {
      path: '/aclip',
      name: 'aclip',
      component: AclIp
    },
    {
      path: '/aclmac',
      name: 'aclmac',
      component: AclMac
    },
    {
      path: '/igmp',
      name: 'igmp',
      component: IgmpSnooping
    },
    {
      path: '/igmpsnooping',
      name: 'igmpsnooping',
      component: IgmpSnooping
    },
    {
      path: '/igmpstatistic',
      name: 'igmpstatistic',
      component: IgmpStatistic
    },
    {
      path: '/qos',
      name: 'qos',
      component: Qos
    },
    {
      path: '/portmirroring',
      name: 'portmirroring',
      component: Mirroring
    },
    {
      path: '/lldpconfig',
      name: 'lldp',
      component: lldpConfig
    },
    {
      path: '/lldpconfig',
      name: 'lldpconfig',
      component: lldpConfig
    },
    {
      path: '/lldpremote',
      name: 'lldpremote',
      component: lldpRemote
    },
    {
      path: '/sysinformation',
      name: 'sysinformation',
      component: SystemInformation
    },
    {
      path: '/syssetting',
      name: 'syssetting',
      alias: 'sysdhcp',
      component: SystemDhcp
    },
    {
      path: '/sysdhcp',
      name: 'sysdhcp',
      component: SystemDhcp
    },
    {
      path: '/syspassword',
      name: 'syspassword',
      component: SystemPassword
    },
    {
      path: '/systime',
      name: 'systime',
      component: SystemTime
    },
    {
      path: '/sysbackup',
      name: 'sysbackup',
      component: SystemBackup
    },
    {
      path: '/systemlog',
      name: 'systemlog',
      component: SystemLog
    },
    {
      path: '/syshttps',
      name: 'syshttps',
      component: SystemHttps
    },
    {
      path: '/syssnmp',
      name: 'syssnmp',
      component: SystemSnmp
    },
    {
      path: '/liveupdate',
      name: 'liveupdate',
      component: LiveUpdate
    },
    {
      path: '/firmwareupdate',
      name: 'firmwareupdate',
      component: FirmwareUpdate
    },
    {
      path: '/debug',
      name: 'debug',
      component: Debug
    },
    {
      path: '/poeconsumption',
      name: 'poeconsumption',
      alias: 'poeconsumption',
      component: PoeConsumption
    },
    {
      path: '/poeconfiguration',
      name: 'poeconfiguration',
      component: PoeConfiguration
    },
    {
      path: '/poeschedule',
      name: 'poeschedule',
      component: PoeSchedule
    },
    {
      path: '/loopprotection',
      name: 'loopprotection',
      component: LoopProtection
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js